<template>
  <div>
    <slot :name="type"></slot>
  </div>
</template>

<script>
export default {
  props: ["type"]
};
</script>

